// Port of api/fuel/app/classes/controller/api/monty/locations/suggest.php
import DB from 'offline/db'
export default function(params) {
	var text = (params.text || '').toLowerCase()
	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: [] } })
	var rows = DB.query("SELECT DISTINCT play_location FROM play WHERE LOWER(play_location) LIKE '%" + text.replace(/'/g, "''") + "%' AND play_location <> '' LIMIT 25")
	var suggestions = rows.map(function(r) { return r.play_location })
	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
